/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-nested-ternary */
import { FC } from 'react';
import { Modal, ModalProps } from 'antd';
import ButtonModalAction from '@app/components/UI/Button/ButtonModalAction';
import { BUTTON_ACTION_TYPE } from '@app/components/UI/Button';
import _ from 'lodash';

interface IAntdModalProps extends ModalProps {
    onClose?: (e: any) => void | null;
    children?: React.ReactNode;
}

const ScModal: FC<IAntdModalProps> = ({
    open,
    onClose,
    title,
    footer,
    className = '',
    zIndex = 1050,
    mask,
    destroyOnHidden = true,
    children,
    ...props
}: IAntdModalProps) => {
    footer = !_.isEmpty(footer)
        ? footer
        : footer == null
          ? null
          : [
                <ButtonModalAction
                    buttonType={BUTTON_ACTION_TYPE.CLOSE}
                    buttonLabel="Thoát"
                    onClick={onClose}
                    key="cancel"
                    disabled={false}
                    type="button"
                    isLeftIcon={false}
                />,
            ];

    return (
        <Modal
            open={open}
            onCancel={onClose}
            title={title}
            className={`sc-antd-modal ${className}`}
            footer={footer}
            zIndex={zIndex}
            mask={{ blur: false, ...(typeof mask === 'object' ? mask : {}) }}
            destroyOnHidden={destroyOnHidden}
            focusable={{ trap: false }}
            afterOpenChange={(isOpen) => {
                if (isOpen) {
                    (document.activeElement as HTMLElement)?.blur?.();
                }
            }}
            {...props}
        >
            {children}
            <div className="clearfix" />
        </Modal>
    );
};

export default ScModal;
